import { Injectable } from '@angular/core';
import { AppConfig } from '../../helper/config/api.config';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { DataService } from '../../../../../Autofacets-Core/src/app/services/data.service';
import { NotificationRequestViewModel } from '../../Models/notification-request-view-model';
import { CallDealerLogEntryRequestModel } from '../../Models/call-dealer-log-entry-requestModel';
import { FileUploadModel } from 'projects/Autofacets-Core/src/app/business-entities/document-model';
@Injectable({
  providedIn: 'root'
})
export class OrderStatusService {
  DemandWiseDocumentCountList= new BehaviorSubject<any[]>([]);
  orderDetails = new BehaviorSubject<any>(undefined);
  repairActualStatusId = new BehaviorSubject<number>(1);
  previousStatusId = new BehaviorSubject<number>(1);
  isOrderSpinnerHide = new Subject<boolean>();
  isStatusSpinnerHide = new Subject<boolean>();
  invoiceClicked = new Subject<boolean>();
  dealerPhoneNo: any;
  constructor(
    private dataProvider: DataService
  ) { }



  GetServicePlans(): Observable<any> {
    return this.dataProvider.Get(AppConfig.GET_ORDER_ServicePlans_DATA_API_URL);
  }

  GetConfiguredStatus(): Observable<any> {
    return this.dataProvider.Get(AppConfig.GET_CONFIGURED_STATUS_API_URL);
  }

  GetAdditionalServiceDetail(): Promise<any> {
    return this.dataProvider.Get<any>(AppConfig.GET_APPOINTMENT_ADDITIONALWORK_DETAIL).toPromise();
  }

  SendCustomerApproval(model: any): Promise<any> {
    return this.dataProvider.Post<any>(AppConfig.SEND_CUSTOMER_APPROVAL, model).toPromise();
  }

  getOrderStatusDetails(): Promise<any> {
    return this.dataProvider.Get(AppConfig.GET_ORDER_STATUS_DATA_API_URL).toPromise();
  }
  GetServiceDetail(language): Promise<any> {
    return this.dataProvider.Get<any>(AppConfig.GET_APPOINTMENT_DETAIL, language).toPromise();
  }
  getInvoicePreview(invoicePreviewRequest: any): Promise<any> {
    return this.dataProvider.Post(AppConfig.GET_INVOICE_PREVIEW, invoicePreviewRequest).toPromise();
  }
  GetDemandWiseDocuments(demandId: number): Promise<any> {
    return this.dataProvider.Get<any>(AppConfig.GET_DEMAND_DOCUMENT, demandId).toPromise();
  }
  updateCustomerOrder(Service: any) {
    return this.dataProvider.Put(AppConfig.UPDATE_CUSTOMER_ORDER_API_URL, Service);
  }
  ApproveAllDemand(model: any) {
    return this.dataProvider.Post(AppConfig.UPDATE_ALLCUSTOMER_ORDER_API_URL, model);
  }
  ApproveAllAdditionalDemand(model: any): Observable<any> {
    return this.dataProvider.Post(AppConfig.UPDATE_ALLADDITIONAL_CUSTOMER_ORDER_API_URL, model);
  }
  getOrderStatusHeaderDetails(): Observable<any> {
    return this.dataProvider.Get(AppConfig.GET_ORDER_STATUS_Header_DATA_API_URL);
  }
  getBrandList(): Observable<any> {
    return this.dataProvider.Get(AppConfig.GET_BRANDS);
  }
  updateOrderStatus(modal: any): Observable<any> {
    return this.dataProvider.Put(AppConfig.UPDATE_ORDER_STATUS_API_URL, modal);
  }

  ServicePrice(): Observable<any> {
    return this.dataProvider.Get(AppConfig.SERVICE_PRICE);
  }

  getInvoiceDetails(): Observable<any> {
    return this.dataProvider.Get(AppConfig.INVOICE_DETAILS);
  }

  GetDetailForInvoice(PdfType: number): Promise<any> {
    return this.dataProvider.Get<any>(AppConfig.TRACKER_INVOICE_DETAILS, PdfType).toPromise();
  }
  GetAppointmentDetail(): Promise<any> {
    return this.dataProvider.Get<any>(AppConfig.APPOINTMENT_DETAILS).toPromise();
  }
  async getPostedInvoiceByWo(appointmentId: number, workOrderNo: string) {
    return this.dataProvider.Get<any>(AppConfig.GET_POSTED_INVOICE, appointmentId, workOrderNo).toPromise();
  }
  async getInvoiceDocument(invoiceNo: string, languageCode: string) {
    return this.dataProvider.Get<any>(AppConfig.GET_INVOICE_DOCUMENT, invoiceNo, languageCode).toPromise();
  }
  GetAppointmentDocumentDetail(): Promise<any> {
    return this.dataProvider.Get<any>(AppConfig.APPOINTMENT_DOCUMENT_DETAILS).toPromise();
  }
  async getDealerDetails(): Promise<any> {
    return this.dataProvider.Get<any>
      (AppConfig.APPOINTMENT_DEALER_DETAILS, 0).toPromise();
  }
  getAuthenticationDetails(): Observable<any> {
    return this.dataProvider.Get(AppConfig.AUTHENTICATION_DETAILS);
  }

  validateOTP(model: any) {
    return this.dataProvider.Post(AppConfig.VALIDATE_OTP, model);
  }

  addDigitalSignature(model: any) {
    return this.dataProvider.Post(AppConfig.ADD_DIGITAL_SIGNATURE, model);
  }

  getCustomerNotifications(model: NotificationRequestViewModel): Observable<any> {
    return this.dataProvider.Post(AppConfig.GetCustomerNotifications, model);
  }
  notificationMarkAllAsRead(): Observable<any> {
    return this.dataProvider.Get(AppConfig.CustomerNotificationMarkAllAsRead);
  }
  notificationMarkAsRead(id: number): Observable<any> {
    return this.dataProvider.Get(AppConfig.CustomerNotificationMarkAsRead, id);
  }
  callDealerLogEntry(request: CallDealerLogEntryRequestModel) {
    return this.dataProvider.Post(AppConfig.CALL_DEALER_LOG_ENTRY_URL, request);
  }

  public UploadCustomerDocument(params: any): Observable<any> {
    let files: FileUploadModel[] = [];
    params.forEach(demand => {
      let index = 0;
      demand.Documents.forEach(doc => {
        files.push({
          uniqueId: "file_" + demand.uniqueId + "_" + index,
          file: doc.actualFile
        });
        doc.imageBinaryData = "";
        index++;
      });
    });
    return this.dataProvider.PostFiles(AppConfig.UploadDocumentFromStatuTracker, params, files);
  }
  GetDocumentCount(): Promise<any> {
    return this.dataProvider.Get(AppConfig.GetDemandWiseDocumentCount).toPromise();
  }
  DownloadFile(fileName: string): Promise<any> {
    return this.dataProvider.Get<any>(AppConfig.DownloadDocument, fileName).toPromise();
  }
}
